import { DefaultButton, Dropdown, Icon, IDropdownOption, Label, Link, MessageBar, MessageBarType, PrimaryButton, Spinner, SpinnerSize, TextField } from '@fluentui/react';
import _ from 'lodash';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import AppConfig from '../../Constants';
import { UserInfoContext } from '../../Main';
import ActivitySyncService from '../../services/activity-sync-service';
import { showActControl, RoleVerbs } from '../../services/PermissionsService';
import ActionScreen from '../Common/ActionScreen';
import { BlockingSpinner } from '../Common/dialogs/BlockingSpinner';
import ButtonWithDialog from '../Common/dialogs/ButtonWithDialog';

import { IProject } from '../Experiment/interfaces/IExperiment';
import FormWrapper from '../FormWrapper';
import ActivityDateOffset from './ActivityDateOffset';
import { cloneActivity, deleteActivityRecordByID, formatActivityDate, formatDateWithFrmt, formatNonTimeDate, getActivityByID, getDropDownOptions, getLocationEquipments, getProjectData, getShiftData, getUniqueLocationObjs, sendVisitorEmail, today, updateActivity, validateEmail } from './ActivityService';
import { IActivity, IActivityEquipment, IActivityShift, IActvityUserRole, IEditActivityFormProps, IEditActivityFormState, IUserPersonaField } from './interfaces/IActivityForm';
import { ILocationShiftAvailability } from './interfaces/ILocationShiftAvailability';
import { IActivitySync } from './interfaces/IOutlookSync';
import LocationsAndEquipments from './LocationsAndEquipments';
import LocationShiftAvailability from './LocationShiftAvailability';
import OutlookSyncForm from './OutLookEventSync/OutlookSyncForm';
import { SyncService } from './OutLookEventSync/SyncService';
import PersonVisitor from './PersonVisitor';
import { v4 as uuidv4 } from 'uuid';
import { IEmailObj } from './interfaces/IEmailObj';

const moment =  require('moment');


const descFieldClass = {
    wrappetr: {
        width: '100%',
        display: 'block',
    },
    root: {
        width: '100%',
    },
    field: {
        height: 200,
    },
};
let InitialErrorMsg = {
    activityDate: '',
    selectedShiftIds: '',
    activityName: '',
    activityDescription: '',
    bookedForEmail: '',
    visitorEmail: '',
    selectedLocations: '',
    activityNotes:''
};
let InitialActivity = {
    ExperimentId:null,
    DayOffset:0,
    ProjectId:0,
    activityDate: new Date(formatActivityDate()),
    selectedShiftIds: [],
    activityName: '',
    activityDescription: '',
    bookedForEmail: [] as IUserPersonaField[],
    bookedByEmail: {} as IUserPersonaField,
    visitorEmail: '',
    selectedLocations: [],
    selectedEquipments: [],
    showVisitorField: false
};
export default class EditActivityForm extends React.Component<IEditActivityFormProps, IEditActivityFormState> {
  constructor(props: IEditActivityFormProps) {
    super(props);
    EditActivityForm.contextType = UserInfoContext;
    this.state = {
        editActivityId:0,
        editActivity: {
            ExperimentId:null,
            ProjectId:0,
            DayOffset:0,
            activityDate: new Date(formatActivityDate()),
            selectedShiftIds: [],
            activityName: '',
            activityDescription: '',
            bookedForEmail: [] as IUserPersonaField[],
            bookedByEmail: {} as IUserPersonaField,
            visitorEmail: '',
            selectedLocations: [],
            selectedEquipments: [],
            showVisitorField: false,
        },
        InitialShifts:[] as IActivityShift[], 
        LocationEquipmentData: [] as IActivityEquipment[],
        Projects:[],
        ShiftTimmings:[],
        Locations: [],
        Equipments: [],
        selectedFor:[],
        LsaArr:[] as ILocationShiftAvailability[],
        formFieldKey:uuidv4(),
        locationEquipKey:uuidv4(),
        errorMsgs:InitialErrorMsg,
        errorMsg:'',
        LSAFullyBooked:false,
        viewForm:false,
        showErrorMsg:false,
        DisableProject:false,
        isLoaded:false,
        isTBDSelected:false,
        ActivityNotSaved:false,
        canEdit: true,
        ShowSyncBtn:false,
        hideDeleteDialog:true,
        hideUpdateDialog:true,
        hideCancelDialog:true,
        hideCloneDialog:true,
        SaveFlag: false,
        isUpdated: false,
        isRedirect: false,
        isCreated: false,
        isDeleted: false,
        isClone:false,
        IsRecordEditable:false,// checks is past, or inactive
        ActSyncData:[] as IActivitySync[],
        ActSyncMsg: "",
        activityNotes: "",
        ActUserRole:"None",
        actionType:"Update",
    }
  }
  private projectsDropDownOptions: IDropdownOption[] = [];
  private initialEditActivity: IActivity = {} as IActivity;
   
  componentDidMount = () => {
    const promises = [];
    promises.push(getShiftData());
    promises.push(getLocationEquipments());
    promises.push(getProjectData());
    promises.push(getActivityByID(this.props.Id));
    promises.push(SyncService.getActivitySyncForUser(this.props.Id,this.context?.userName));
    Promise.all(promises).then((responses:any) => {
        this.setState({isLoaded:true});
            if (responses.length > 0) {
                let shifts:IActivityShift[] = responses[0] ? _.filter(responses[0],{StatusId:AppConfig.ActivityForm.ActiveStatusId}) : [];
                let locationEquipmentData:IActivityEquipment[] = responses[1]? responses[1]: [];
                let projectData:IProject[] = responses[2]? responses[2]: [];
                let currActivityData:any = responses[3]? responses[3]: [];
                let actSyncData:IActivitySync[] = responses[4]? responses[4]: [];
                this.arrangeFormFields(shifts, locationEquipmentData, projectData, currActivityData, actSyncData);
            }
            else {
                this.setState({
                    isLoaded:true,
                    showErrorMsg: true,
                    errorMsg: AppConfig.ActivityForm.ErrorDataFetchMessage
                });
            }
        })
        .catch(error => {
            this.setState({
                isLoaded:true,
                showErrorMsg: true,
                errorMsg: AppConfig.ActivityForm.ErrorDataFetchMessage
            });
            console.log(error);
        });
    }
    componentDidUpdate(prevProps:IEditActivityFormProps, prevState:IEditActivityFormState) {
        const {Id,ExpData} = this.props;
        const {editActivity} = this.state;
        if(prevProps.Id!==Id){
            getActivityByID(this.props.Id).then((response)=>{
                if (response > 0) {
                    let currActivityData:any = response? response: [];
                    const {LocationEquipmentData,InitialShifts,Projects,ActSyncData} = this.state;
                    this.arrangeFormFields(InitialShifts, LocationEquipmentData, currActivityData,Projects,ActSyncData);
                } else {
                        this.setState({
                            editActivityId:this.props.Id,
                            isLoaded:true,
                            showErrorMsg: true,
                            errorMsg: AppConfig.ActivityForm.ErrorDataFetchMessage
                        });
                }
            });
        }
        if(ExpData && prevProps.ExpData){
            if(ExpData.ExpOwnerEmail !== prevProps.ExpData.ExpOwnerEmail && !ExpData.ExperimentNotSaved){
                editActivity.ExperimentOwner = ExpData.ExpOwnerEmail;
                this.setState({
                    editActivity
                });
            }
            if(ExpData.ProjectId !== prevProps.ExpData.ProjectId){
                editActivity.ProjectId = ExpData.ProjectId;
                this.setState({
                    editActivity
                });
            }
            let prevExpDate = moment(editActivity.ExperimentStartDate);
            let expDate = moment(ExpData.ExpStartDate);
            let dateDiff = expDate.diff(prevExpDate,'days',true);
            if(dateDiff !== 0 && !ExpData.ExperimentNotSaved){
                editActivity.ExperimentOwner = ExpData.ExpOwnerEmail;
                editActivity.ExperimentStartDate = ExpData.ExpStartDate;
                // editActivity.activityDate = ExpData.ExpStartDate;
                this.setState({
                    editActivity,
                    formFieldKey:uuidv4()
                });
            }
            if(ExpData.ExperimentNotSaved !== prevProps.ExpData.ExperimentNotSaved){
                this.setState({
                    formFieldKey:uuidv4()
                });
            }
        }
    }
    arrangeFormFields = (shifts:IActivityShift[], locationEquipmentData:IActivityEquipment[],projectData:IProject[],currActivityData:any,actSyncData:IActivitySync[]) => {
        let shiftsArr:IActivityShift[] = this.prepareShiftsData(shifts);
        let uniqLocationsArr = getUniqueLocationObjs(locationEquipmentData, this.props.office);
        this.projectsDropDownOptions = getDropDownOptions(projectData,'Name');

        let editActivity:IActivity = this.getActivityDetailData(currActivityData);        
        this.initialEditActivity = JSON.parse(JSON.stringify(editActivity));
        let activityShifts = this.getShiftsSelection(shiftsArr,editActivity.selectedShiftIds);
        let canEdit:boolean = false;
        let IsRecordEditable:boolean = false;
        let ShowSyncBtn:boolean = false;
        let canUserEdit:IActvityUserRole= this.checkIfUserAdmiOrEditor(editActivity);
        if(canUserEdit.isEditor){
            var isEditable:boolean = this.checkIfRecordIsEditable(editActivity);
            canEdit = isEditable && showActControl(this.context,canUserEdit.UserRole,RoleVerbs.Edit);
            IsRecordEditable = isEditable;
            ShowSyncBtn = isEditable;
        }
        else{
            ShowSyncBtn = this.checkIfRecordIsEditable(editActivity);
            canEdit = canUserEdit.isEditor;
        }
        let selectedFor =  editActivity.showVisitorField?[]:editActivity.bookedForEmail;
        const {viewForm,ExpData} = this.props;
        let disableProjectIfExp:boolean = false;
        if(ExpData){    
            disableProjectIfExp = true;    
            editActivity.ExperimentId = ExpData.ExpId;
            editActivity.ProjectId = ExpData.ProjectId;
            editActivity.ExperimentOwner = ExpData.ExpOwnerEmail;
            let expDate = formatNonTimeDate(ExpData.ExpStartDate);
            editActivity.ExperimentStartDate =  expDate?new Date(expDate):null;
        }
        if(editActivity.ExperimentId){
            disableProjectIfExp = true;
        }
        let isViewForm:boolean = false;
        if(canUserEdit.UserRole === "Admin"){
            isViewForm = viewForm? viewForm: false;
        }else{
            isViewForm = viewForm || !canEdit;
        }
        this.setState({
            editActivityId:this.props.Id,
            editActivity: editActivity,
            InitialShifts:shifts,
            ShiftTimmings: activityShifts,
            Projects:projectData,
            Locations: uniqLocationsArr,
            Equipments:locationEquipmentData,            
            DisableProject:disableProjectIfExp,
            isLoaded: true,
            locationEquipKey: uuidv4(),
            selectedFor,
            isTBDSelected:this.isTBDSelected(editActivity.selectedShiftIds),
            ActSyncData:this.getActiveSync(actSyncData),
            LocationEquipmentData: locationEquipmentData,           
            canEdit,
            IsRecordEditable,
            ShowSyncBtn,
            viewForm: isViewForm,
            ActUserRole:canUserEdit.UserRole
        });
        if(ExpData){
            if(this.props.handleActivityActions){
                this.props.handleActivityActions("Form Loaded", "LoadForm");
            }
        }
    }
    prepareShiftsData = (shifts:IActivityShift[]):IActivityShift[] =>{
        var shiftArr:IActivityShift[] = [];
        if (!AppConfig.ActivityForm.showTBD) {
            shifts = _.reject(shifts, {DisplayName: AppConfig.ActivityForm.TBDRejectDispName});
            shifts.map(element => {
                return (element.isSelected = false);
            });
            shiftArr = shifts;
        } else {
            //arrange TBD to be first place
            let tbdShiftArr = _.filter(shifts, {DisplayName: AppConfig.ActivityForm.TBDRejectDispName});
            if (tbdShiftArr && tbdShiftArr.length > 0) {
                let tbdShift = tbdShiftArr[0];
                tbdShift.isSelected = false;
                shifts = _.reject(shifts, {DisplayName: AppConfig.ActivityForm.TBDRejectDispName});
                shiftArr.push(tbdShift);
                for (let sndex = 0; sndex < shifts.length; sndex++) {
                    const shiftElm = shifts[sndex];
                    shiftElm.isSelected = false;
                    shiftArr.push(shiftElm);
                }
            } else {
                for (let sndex = 0; sndex < shifts.length; sndex++) {
                    const shiftElm = shifts[sndex];
                    shiftElm.isSelected = false;
                    shiftArr.push(shiftElm);
                }
            }
        }
        return shiftArr;
    }
    getShiftsSelection(shiftArr: IActivityShift[], selectedShiftIds: number[]) {
        for (let shiftIndex = 0; shiftIndex < shiftArr.length; shiftIndex++) {
            const shiftRecord = shiftArr[shiftIndex];
            if(selectedShiftIds.indexOf(shiftRecord.Id)!== -1){
                shiftRecord.isSelected = true;
            }else{
                shiftRecord.isSelected = false;
            }            
        }
        return shiftArr;
    }
    checkExpDateIsPast = (expDate:any) =>{
        var currExpDate = moment(expDate);
        var currDate = moment(today);
        var diffDates = currDate.diff(currExpDate,'days');
        if(expDate && diffDates>0){
            return new Date(formatActivityDate());
        }
        else{
            return expDate;
        }
    }
    isTBDSelected = (selectedShifts:number[]):boolean =>{
        if(selectedShifts.indexOf(AppConfig.ActivityForm.TBDRejectShiftId) !==-1){
            return true;
        }
        return false;
    }
    getActivityDetailData(currActivityData: any): IActivity {
        var editActivity:IActivity = {...InitialActivity};
        try {
            var activityDetails = currActivityData.ActivytData[0];
            editActivity.Id = activityDetails.ActivityId;
            var actDate = formatNonTimeDate(activityDetails.ActivityDate);
            editActivity.activityDate = actDate?new Date(actDate):null;
            editActivity.activityName = activityDetails.ActivityName;
            editActivity.activityDescription = activityDetails.ActivityDescription;
            editActivity.showVisitorField = !activityDetails.IsEmployee;
            editActivity.ProjectId = activityDetails.ActivityProjectId;
            if(activityDetails.IsEmployee){
                let obj:IUserPersonaField = {} as IUserPersonaField;
                obj.DisplayName = activityDetails.BookedForName;
                obj.Email = activityDetails.BookedForEmail;
                editActivity.bookedForEmail = [];
                editActivity.bookedForEmail.push(obj);
            }else{
                editActivity.showVisitorField = true;
                editActivity.visitorEmail = activityDetails.BookedForEmail
            }
            let obj:IUserPersonaField = {} as IUserPersonaField;
                obj.DisplayName = activityDetails.BookedByName;
                obj.Email = activityDetails.BookedByEmail;
                editActivity.bookedByEmail = obj;
            
            editActivity.DayOffset = activityDetails.DayOffset;
            
            editActivity.selectedShiftIds = currActivityData.ActivityShift;
            editActivity.selectedLocations = currActivityData.ActivityLocation;
            editActivity.selectedEquipments = currActivityData.ActivityEquipment;
            //experiment Data
            editActivity.ExperimentId = activityDetails.ExperimentId;
            editActivity.ExperimentOwner = activityDetails.ExperimentOwner;
            editActivity.ExperimentStatusId = activityDetails.ExperimentStatusId;
            var expDate = formatNonTimeDate(activityDetails.ExperimentStartDate);
            editActivity.ExperimentStartDate = expDate?new Date(expDate):null;
            editActivity.ActivityStatus = activityDetails.ActivityStatus;            
        } 
        catch (error) {
            console.log(error);
        }
        return editActivity;
    }
    checkIfUserAdmiOrEditor = (editActivity: IActivity):IActvityUserRole=> {
        var userRole:IActvityUserRole = {} as IActvityUserRole;
        console.log(this.context);
        userRole.UserRole = "None";
           try {
            if(this.context?.isAdmin){
                userRole.isEditor = true;
                userRole.UserRole = "Admin";                
            }
            else{                            
                    //individual Activity
                if(editActivity.bookedByEmail.Email.toUpperCase() === this.context?.userName.toUpperCase()){
                    userRole.isEditor = true;
                    userRole.UserRole = "Actowner";  
                }
                if(!editActivity.showVisitorField && 
                    editActivity.bookedForEmail[0].Email.toUpperCase() === this.context?.userName.toUpperCase()){
                    userRole.isEditor = true;
                    userRole.UserRole = "Actowner";
                } 
                if(editActivity.ExperimentId){
                    //check for experiment owner
                    if(editActivity.ExperimentOwner?.toUpperCase() === this.context?.userName.toUpperCase()){
                        userRole.isEditor = true;
                        userRole.UserRole ="ExpOwner";
                    }
                }              
            }
           } catch (error) {
               console.log("checkIfUserAdmiOrEditor", error);
           }
            console.log("Can Edit", userRole.isEditor);
        return userRole;
    } 
    checkIfRecordIsEditable = (editActivity: IActivity):boolean=> {
        var isEditable:boolean = true;
        var currActivityDate = moment(editActivity.activityDate);
        var currDate = moment(today);
        var diffDates = currDate.diff(currActivityDate,'days');
        var officeLocId = AppConfig.ActivityForm.officeSpaceUsageLocation;
        try {
            if(editActivity.ActivityStatus === AppConfig.ActivityForm.InactiveStatusId){
                isEditable = false;
            }
            if(editActivity.activityDate && diffDates>0){
                isEditable = false;
            }
            if(this.props.office){
                if(editActivity.selectedEquipments.length>0){
                    isEditable = false;
                }
                if(editActivity.selectedLocations.length>1){
                    isEditable = false;
                }
                if(editActivity.selectedLocations[0] !== officeLocId ){
                    isEditable = false;
                }
            }
            else{
                if(editActivity.selectedLocations.indexOf(officeLocId) !== -1){
                    isEditable = false;
                }                           
            }
            if(editActivity.ExperimentId){
                if(editActivity.ExperimentStatusId === AppConfig.ActivityForm.InactiveStatusId){
                    isEditable = false;
                }
            }
        } catch (error) {
            console.log("checkIfRecordIsEditable", error);            
        }
            console.log("isEditable", isEditable);
        return isEditable;
    } 
    getActiveSync(actSyncData: IActivitySync[]): IActivitySync[] {
        let filteredObj:IActivitySync[] = [] as IActivitySync[];
        filteredObj =  _.filter(actSyncData,{StatusId:1});
        if(filteredObj && filteredObj.length>0){
            return filteredObj;
        }
        return [] as IActivitySync[];
    }


    handleActDateChange = (updateProp:any, field:string) =>{
        const {editActivity} :any = this.state;
        editActivity[field] = updateProp;
        this.setState({
            editActivity,
            showErrorMsg: false,
            ActivityNotSaved:true,
            errorMsg: ''
        }); 
    }
    handleTextFieldsChange  = (event:any,newValue:any) =>{
        const {editActivity} :any = this.state;
        let fieldName:any = event.target.name;
        let value:any = newValue;
        if(value.trim() === '') {
            editActivity[fieldName] = '';
        } else {
            editActivity[fieldName] = value;
        }
        this.setState({editActivity});
    }
    handleProjectChange  = (event:any,option:IDropdownOption|undefined) =>{
        const {editActivity} = this.state;
        if(option){
            editActivity.ProjectId = parseInt(option.key.toString());
            this.setState({ActivityNotSaved:true,editActivity});
        }
    }
    handlePersonVisitorChange = (eventObj:any) => {
        const {editActivity,LsaArr} :any = this.state, val = eventObj.target.value;
        if(eventObj.target.name === 'visitorEmail'){
            let rasieAlert = this.alertLSAFullyBooked(LsaArr,val);
            editActivity[eventObj.target.name] = val;
            this.setState({
                editActivity,
                ActivityNotSaved:true,
                showErrorMsg: rasieAlert,
                errorMsg: rasieAlert? AppConfig.ActivityForm.FullyBookedAlertMsg:''
            });
        }
        else if(eventObj.target.name === "bookedForEmail"){
            let rasieAlert = val.length>0?this.alertLSAFullyBooked(LsaArr,val[0].Email):false;
            editActivity[eventObj.target.name] = val;
            this.setState({
                editActivity,
                ActivityNotSaved:true,
                selectedFor:eventObj.target.selectedFor,
                showErrorMsg: rasieAlert,
                errorMsg: rasieAlert? AppConfig.ActivityForm.FullyBookedAlertMsg:''
            });
        }
        else if(eventObj.target.name === "showVisitorField"){
            let rasieAlert = this.alertLSAFullyBooked(LsaArr,val);
            editActivity[eventObj.target.name] = val;
            // editActivity.bookedForEmail = [];
            editActivity.visitorEmail = '';
            this.setState({
                editActivity,
                ActivityNotSaved:true,
                showErrorMsg: rasieAlert,
                errorMsg: rasieAlert? AppConfig.ActivityForm.FullyBookedAlertMsg:''
            });
        }
        else{
            this.setState({
                editActivity: editActivity,
                ActivityNotSaved:true
            });
        }
    }
    handleEquipmentSelection = (updateProp:any, field:string) => {
        let editActivity:any= this.state.editActivity;
        editActivity[field] = updateProp;
        this.setState({
            editActivity,
            ActivityNotSaved:true
        });
    }
    handleLocationSelection = (locationValues:any, equipValues:string) => {
        const {editActivity,LsaArr} :any = this.state;
        editActivity['selectedLocations'] = locationValues;
        editActivity['selectedEquipments'] = equipValues;
        var rasieAlert = this.alertLSAFullyBooked(LsaArr);
        this.setState({
            editActivity,
            showErrorMsg: rasieAlert,
            ActivityNotSaved:true,
            errorMsg: rasieAlert?AppConfig.ActivityForm.FullyBookedAlertMsg:''
        });
    }
    handleShiftChange = (event:any) =>{
        var options:any = event.target.options;
        const {editActivity, LsaArr} :any = this.state;
        var values:number[]  = this.getOptionsSelected(options);
        var rasieAlert = this.alertLSAFullyBooked(LsaArr);

        editActivity.selectedShiftIds = values;
        this.setState({
            editActivity,
            showErrorMsg:rasieAlert,
            errorMsg: rasieAlert?AppConfig.ActivityForm.FullyBookedAlertMsg:''
        });
    }
    handleMultiSelectClear = (event:any) => {
        let fieldName:any = event.target.name;
        const {editActivity} = this.state;
        if (fieldName  === "Shift") {
            editActivity.selectedShiftIds = [];
            this.setState({editActivity});
        }
    }
    updateStateLSA = (lsaArr:any) => {
        var raiseError = this.alertLSAFullyBooked(lsaArr);
        const{showErrorMsg} = this.state;
        this.setState({
            LsaArr:lsaArr,
            showErrorMsg:showErrorMsg?showErrorMsg:raiseError,
            errorMsg: AppConfig.ActivityForm.FullyBookedAlertMsg
        });
    }


    renderErrorMsgForField(msg:string,key:any){
        return(
            <div role="alert" key={key}>
                <p className="ms-TextField-errorMessage alertMsg">
                    <span data-automation-id="error-message">{msg}</span>
                </p>
            </div>
        );
    }
    renderErrorMsg(msg:string){
        return(
            <MessageBar messageBarType={MessageBarType.error} className={"errorMsgInfo"}>
                {msg}
            </MessageBar>
        );
    }
    renderCloneInfoMsg(){
        const {CloneTime} = this.props;
        let currTime = new Date().getTime();
        let type = this.props.office?"Office Usage":"Lab Activity"; 
        let msg = type +" is clonned successfully. You can update the details of the cloned"+ type +" here.";
        if( CloneTime && currTime<CloneTime){
            return(
                <MessageBar messageBarType={MessageBarType.success} className={"errorMsgInfo"}>
                    {msg}
                </MessageBar>
            );
        }
        return '';
    }
    renderActSyncMsg = (ActSyncMsg:string)  =>{
        if(ActSyncMsg === "Push"){
            return(
                <MessageBar messageBarType={MessageBarType.success} className={"errorMsgInfo"}>
                    Activity added to your outlook calendar successfully.
                </MessageBar>
            );
        }
        if(ActSyncMsg === "Error"){
            return(
                <MessageBar messageBarType={MessageBarType.error} className={"errorMsgInfo"}>
                    Activity addition to your outlook calendar failed. Please try after sometime.
                </MessageBar>
            );
        }
        if(ActSyncMsg === "Delete"){
            return(
                <MessageBar messageBarType={MessageBarType.success} className={"errorMsgInfo"}>
                    Deleted activity event from outlook calendar.
                </MessageBar>
            );
        } 
        if(ActSyncMsg === "Update"){
            return(
                <MessageBar messageBarType={MessageBarType.success} className={"errorMsgInfo"}>
                    Updated activity event in your outlook calendar.
                </MessageBar>
            );
        }
    }
    loadSpinner = (labelTxt:string,isLoading:boolean) => {
        return (
            <div className="centeredContainer">
                <BlockingSpinner label={labelTxt} hideDialog={!isLoading}/>
            </div>
        );
    }
    getRedirectURI = (office:boolean|undefined) =>{
        const {editActivity, editActivityId} = this.state;
        let CurrTimePlus2 =  new Date(new Date().getTime() + 1*60000).getTime();
        let cloneParams = '&ParentId='+editActivity.Id + '&CloneTime='+CurrTimePlus2;
       return office? '/PlanOfficeSpace?id='+editActivityId+cloneParams: '/PlanActivity?id='+editActivityId+cloneParams;
    }
    handleActionAndRediret(): JSX.Element {
        const {
            isCreated,
            isUpdated,
            isDeleted,
            actionType,
            editActivityId,
            canEdit,
            isClone,
            viewForm,
            ActUserRole,         
        } = this.state;
        const {office,NotPopActions} = this.props;
        const subText = office? 'Office Usage' : 'Lab Activity';
        const redirectURL = office? '/PlanOfficeSpace?Id='+editActivityId : '/PlanActivity?Id='+editActivityId;
        const redirectURI = this.getRedirectURI(office);
        return(
            <div>
                {isUpdated && !NotPopActions?(
                        <ActionScreen 
                            subText= {subText+' updated. Redirecting to edit page...'}
                            dialogTitle= {'Updated Successfully'}
                            actionBtnTxt= {'go Home'}
                            showModal= {isUpdated}
                            isBlocking={true}
                            actionType ={actionType}
                            shouldDefaultRedirect= {true}
                            defaulltRedirectURI= {redirectURL}
                            timmer={AppConfig.ActivityForm.FormRedirectionTimmer}
                        />
                ):''}
                {isDeleted && !NotPopActions?(
                        <ActionScreen 
                            subText= {subText+' Deleted. Redirecting to Home page...'}
                            dialogTitle= {'Deleted Successfully'}
                            actionBtnTxt= {'go Home'}
                            showModal= {isDeleted}
                            isBlocking={true}
                            actionType ={actionType}
                            shouldDefaultRedirect= {true}
                            defaulltRedirectURI= {'/Home'}
                            timmer={AppConfig.ActivityForm.FormRedirectionTimmer}
                        />
                ):''}
                {isCreated && !NotPopActions?(
                    <ActionScreen 
                        subText= {subText+' Cloned. Redirecting to newly created '+subText+'...'}
                        dialogTitle= {'Created Successfully'}
                        isBlocking={true}
                        actionBtnTxt= {'go Home'}
                        showModal= {isCreated}
                        actionType ={actionType}
                        shouldDefaultRedirect= {true}
                        defaulltRedirectURI= {redirectURI}
                        timmer={AppConfig.ActivityForm.FormRedirectionTimmer}
                    />
                ):''}
                {!canEdit && ActUserRole !=="Admin" && !NotPopActions && !viewForm &&!isClone?(
                    <ActionScreen 
                        subText= {'Do not have permission to edit the '+ subText}
                        dialogTitle= {'Access Denied'}
                        isBlocking={false}
                        actionBtnTxt= {'go Home'}
                        showModal= {true}
                        isActionBtnVisible={true}
                        shouldDefaultRedirect={false}
                        leftBtnText= {'Go Home'}
                        leftBtnURI= {'/Home'}
                        rightBtnText= {'My Activities'}
                        rightBtnURI= {'/MyActivities'}
                        actionType ={"Denied"}
                    />
                ):''}
            </div>
        );       
    } 
    public render() {
        const {office,ExpData} =this.props;
        const {ShiftTimmings, Locations, Equipments, editActivity, formFieldKey, viewForm, errorMsgs, DisableProject,isLoaded, locationEquipKey, selectedFor, 
            LSAFullyBooked, ActSyncMsg, ActUserRole, showErrorMsg,errorMsg, canEdit, IsRecordEditable, hideCloneDialog, ShowSyncBtn, ActivityNotSaved, ActSyncData,
            isTBDSelected, hideCancelDialog, hideDeleteDialog, hideUpdateDialog, activityNotes, SaveFlag, isClone, isRedirect} = this.state;
        const formHeading1 = viewForm? 'View ':'Edit ';
        const formHeading2 = 'Lab Activity';
        const dialogMsg = AppConfig.ActivityForm.FullyBookedDialogMsg;
        var updateTxt ='Are you sure you want to update the '+formHeading2+'? Please add notes for the update.';
        var updateTxtAdmin ='Are you sure you want to update the '+formHeading2+' which belongs to past? Please add notes for the update.';
        var lsaFullyBooked = dialogMsg;
        updateTxt = LSAFullyBooked?lsaFullyBooked+updateTxt:updateTxt;
        updateTxtAdmin = LSAFullyBooked?lsaFullyBooked+updateTxt:updateTxt;
        return (
            <div className="formMain">
            {isLoaded ? (
                <> 
                    <FormWrapper FormHeading={formHeading1+formHeading2}>
                        {this.props.ParentId?(this.renderCloneInfoMsg()):''}
                        {ActSyncMsg?(this.renderActSyncMsg(ActSyncMsg)):''}
                        <div className="ms-Grid" dir="ltr">
                            <div className="ms-Grid-row" style={{marginBottom:"5px"}}>
                                <div className="ms-Grid-col ms-sm12">
                                    <div className="ms-Grid-col ms-sm4"> 
                                        <div style={{width: "100%",display:"flex",justifyContent:"flex-start"}}>
                                            <ActivityDateOffset key={formFieldKey.toString()}
                                                activityDate={editActivity.activityDate}
                                                viewForm={viewForm}
                                                isPast={ActUserRole==="Admin"}
                                                ExpId={editActivity.ExperimentId}
                                                ExpDate={editActivity.ExperimentStartDate}
                                                errorMsgs={errorMsgs}
                                                handleFormFieldChange={this.handleActDateChange}/>
                                            <div style={{width: "2%"}}></div>
                                            <div style={{width: "45%"}}>
                                                <Dropdown
                                                    required
                                                    placeholder="Select Project / Study"
                                                    label="Project / Study"
                                                    disabled={viewForm || DisableProject}
                                                    selectedKey={editActivity.ProjectId}
                                                    options={this.projectsDropDownOptions}
                                                    errorMessage={errorMsgs.ProjectId}
                                                    onChange={this.handleProjectChange}
                                                />
                                            </div>
                                        </div>
                                        <TextField 
                                            required
                                            label="Activity Name"
                                            name="activityName"
                                            placeholder="Activity Name"
                                            disabled={viewForm}
                                            value={editActivity.activityName}
                                            errorMessage={errorMsgs.activityName}
                                            onChange={this.handleTextFieldsChange}/>
                                        <TextField 
                                            multiline={true} 
                                            rows={3} 
                                            style={{height:"50px"}} 
                                            label="Activity Description" 
                                            name="activityDescription"
                                            placeholder="Activity Description"
                                            value={editActivity.activityDescription}
                                            disabled={viewForm}
                                            errorMessage={errorMsgs.activityDescription}
                                            onChange={this.handleTextFieldsChange}
                                            styles={descFieldClass}/>       
                                        <PersonVisitor key={formFieldKey.toString()}
                                            errorMsgs ={errorMsgs}
                                            viewForm={viewForm}
                                            selectedFor={selectedFor}                                        
                                            showVisitorField ={editActivity.showVisitorField}
                                            visitorEmail={editActivity.visitorEmail}
                                            handleOnChange={this.handlePersonVisitorChange}/>  
                                        <div style={{width: "100%",display:"flex",justifyContent:"space-between"}}>
                                            <div style={{width: "31%"}}>
                                                <div style={{display:"flex",alignItems:"center",justifyContent:"left"}}>
                                                    <Label className={'requiredLabel'} title={'Use SHIFT to select a range of shifts,\nUse CTRL to select non-contiguous shifts.'}>Shift(s)</Label>
                                                    <div style={{fontSize:12}}>
                                                        <Icon style={{fontSize:"14px",cursor:"pointer",verticalAlign:"middle"}} iconName={'Info'}  
                                                            title={'Use SHIFT to select a range of shifts,\nUse CTRL to select non-contiguous shifts '}/>
                                                    </div>
                                                </div>
                                                <select 
                                                    disabled={viewForm}
                                                    style={{width: "100%", height: "200px",fontSize:"12px", color:"black!important"}}
                                                    multiple={true}
                                                    id={"selectedShiftIds"}
                                                    required={true}
                                                    onChange={e => this.handleShiftChange(e)}>
                                                        {this.renderShifts(ShiftTimmings,editActivity.selectedShiftIds)}
                                                </select>
                                                <Link name={"Shift"} onClick ={this.handleMultiSelectClear} style={{fontSize:"12px", color:"black!important"}}>Clear</Link>
                                                {errorMsgs.selectedShiftIds?this.renderErrorMsgForField(errorMsgs.selectedShiftIds,'selectedShiftIdsError'):''}
                                            </div>
                                            <LocationsAndEquipments key={locationEquipKey}
                                                viewForm={viewForm}
                                                locationEquipKey={locationEquipKey}
                                                Equipments={Equipments}
                                                Locations={Locations}
                                                errorMsgs={errorMsgs}
                                                selectedLocations={editActivity.selectedLocations}
                                                selectedEquipments={editActivity.selectedEquipments}
                                                handleLocationSelectionChange={this.handleLocationSelection}
                                                handleEquipmentSelectionChange={this.handleEquipmentSelection}/>
                                        </div>
                                    </div>                    
                                    <div  className="ms-Grid-col ms-sm8 shiftLocation heightFix" >
                                        <LocationShiftAvailability key={formFieldKey.toString()}
                                            selectedLocations={editActivity.selectedLocations}
                                            sendLsaArr ={this.updateStateLSA}
                                            Shifts={ShiftTimmings}
                                            office={false}
                                            Locations={Locations}
                                            activityDate={formatActivityDate(editActivity.activityDate)}/>
                                    </div>
                                </div>                                                             
                            </div>  
                            {showErrorMsg && this.renderErrorMsg(errorMsg)}
                            {!canEdit && ActUserRole !=="Admin" && this.renderErrorMsg('Access Denied: This record cannot be modified. Only a system Administrator can delete the activity.')}
                            {!canEdit && ActUserRole ==="Admin" && this.renderErrorMsg('As a System Administrator only you can modify this activity. The activity is either from  past or inactive.')}
                            <div className={ExpData?.ExperimentNotSaved?"displayNone":"row formHeadflex"} key="divButtons">
                                {viewForm && (
                                    <div className={'button-right'}>
                                        <div className={'leftBtns'}>
                                            {canEdit && showActControl(this.context,ActUserRole,RoleVerbs.Edit) && (
                                                <PrimaryButton
                                                    key="EditView1"
                                                    text="Edit"
                                                    iconProps={{iconName:"Edit"}} 
                                                    data-action={'Edit'}
                                                    onClick={this.handleEditClick}
                                                /> 
                                            )}                                        
                                            {!IsRecordEditable && showActControl(this.context,ActUserRole,RoleVerbs.EditPast) && (
                                                <PrimaryButton
                                                    key="EditView2"
                                                    text="Edit"
                                                    iconProps={{iconName:"Edit"}} 
                                                    data-action={'Edit'}
                                                    onClick={this.handleEditClick}
                                                 /> 
                                            )}                                        
                                            {this.props.ExpData && ActUserRole !== "None" &&(  
                                                <ButtonWithDialog key={'CloneView1'}
                                                    CustClassName ={"BlockingDialog"}
                                                    iconString={'Copy'}
                                                    hideDialog={hideCloneDialog}
                                                    buttonTxt={'Clone'}
                                                    onBtnClick={this.handleCloneClick}
                                                    buttonType={'Primary'}
                                                    dialogTitle={'Clone?'}
                                                    subText={"This will create a copy of this "+formHeading2+" and display it so you can update the date and other details. Do you want to proceed?"}
                                                    isBlocking={false}
                                                    handleAction={this.handleAddClick}
                                                    actionBtnTxt={'Yes'}
                                                    dismisBtnTxt={'No'}>                                            
                                                </ButtonWithDialog>
                                             )}
                                            {!this.props.ExpData && (
                                                <ButtonWithDialog key={'CloneView2'}
                                                    CustClassName ={"BlockingDialog"}
                                                    iconString={'Copy'}
                                                    hideDialog={hideCloneDialog}
                                                    buttonTxt={'Clone'}
                                                    onBtnClick={this.handleCloneClick}
                                                    buttonType={'Primary'}
                                                    dialogTitle={'Clone?'}
                                                    subText={"This will create a copy of this "+formHeading2+" and display it so you can update the date and other details. Do you want to proceed?"}
                                                    isBlocking={false}
                                                    handleAction={this.handleAddClick}
                                                    actionBtnTxt={'Yes'}
                                                    dismisBtnTxt={'No'}>                                            
                                                </ButtonWithDialog>
                                            )}                                                                                       
                                            <OutlookSyncForm ActivityDetails={{...editActivity}} Shifts={ShiftTimmings} 
                                                Locations={Locations} ActivitySyncData={ActSyncData} isSynched={ActSyncData.length>0} 
                                                disabled={!ShowSyncBtn || ActivityNotSaved ||isTBDSelected||editActivity.showVisitorField || this.isEventIdPresent()}
                                                handleActSyncSave={this.handleActSyncSave}/>
                                            <DefaultButton
                                                key="Close"
                                                iconProps={{iconName:"Cancel"}} 
                                                onClick={this.handleCancelAction}
                                                text="Close"/>
                                        </div>
                                        <div style={{display:"flex"}}>
                                            {showActControl(this.context,ActUserRole,RoleVerbs.DeletePast)  && !IsRecordEditable && (
                                                <ButtonWithDialog key={'DeleteView2'}
                                                    CustClassName ={"BlockingDialog"}
                                                    iconString={'Delete'}
                                                    hideDialog={hideDeleteDialog}
                                                    buttonTxt={'Delete'}
                                                    onBtnClick={this.handleDelete}
                                                    buttonType={'Primary'}
                                                    dialogTitle={'Delete?'}
                                                    subText={'The activity belongs to the past. Are you still sure you want to delete the activity? '}
                                                    isBlocking={false}
                                                    handleAction={this.handleDeleteAction}
                                                    actionBtnTxt={'Delete'}
                                                    dismisBtnTxt={'Cancel'}>                                             
                                                </ButtonWithDialog>
                                            )}
                                            {showActControl(this.context,ActUserRole,RoleVerbs.DeletePast) && IsRecordEditable && (
                                                <ButtonWithDialog key={'DeleteView1'}
                                                    CustClassName ={"BlockingDialog"}
                                                    iconString={'Delete'}
                                                    hideDialog={hideDeleteDialog}
                                                    buttonTxt={'Delete'}
                                                    onBtnClick={this.handleDelete}
                                                    buttonType={'Primary'}
                                                    dialogTitle={'Delete?'}
                                                    subText={'The activity either belongs to the past or is inactive. Are you still sure you want to delete the activity? '}
                                                    isBlocking={false}
                                                    handleAction={this.handleDeleteAction}
                                                    actionBtnTxt={'Delete'}
                                                    dismisBtnTxt={'Cancel'}>                                             
                                                </ButtonWithDialog>
                                            )}  
                                        </div>
                                    </div>
                                )}                               
                                <div className={viewForm || isClone?"displayNone":"button-right"}>
                                    <div className={'leftBtns'}>
                                        {showActControl(this.context,ActUserRole,RoleVerbs.Edit) && (
                                            <ButtonWithDialog key={'update'}
                                                CustClassName ={"BlockingDialog"}
                                                hideDialog={hideUpdateDialog}
                                                buttonTxt={'Update'}
                                                iconString={"Edit"}
                                                onBtnClick={this.handleFormSaveClick}
                                                buttonType={'Primary'}
                                                dialogTitle={'Update?'}
                                                subText={ActUserRole === "Admin"? updateTxtAdmin:updateTxt}
                                                isBlocking={true}
                                                handleAction={this.handleUpdateAction}
                                                actionBtnTxt={'Update'}
                                                dismisBtnTxt={'Cancel'}
                                                disabled={viewForm}>
                                                <div>
                                                    <TextField
                                                        multiline
                                                        label="Notes (Optional)"
                                                        name="activityNotes"
                                                        placeholder="Change Reason"
                                                        value={activityNotes}
                                                        errorMessage={errorMsgs.activityNotes}
                                                        onChange={this.handleNotesChange}
                                                    />
                                                </div>                                               
                                            </ButtonWithDialog>
                                        )}
                                        {this.props.ExpData && ActUserRole !== "None" && (
                                            <ButtonWithDialog key={'CloneUpdate1'}
                                                CustClassName ={"BlockingDialog"}
                                                iconString={'Copy'}
                                                hideDialog={hideCloneDialog}
                                                buttonTxt={'Clone'}
                                                onBtnClick={this.handleCloneClick}
                                                buttonType={'Primary'}
                                                dialogTitle={'Clone?'}
                                                subText={"This will create a copy of this "+formHeading2+" and display it so you can update the date and other details. Do you want to proceed?"}
                                                isBlocking={false}
                                                handleAction={this.handleAddClick}
                                                actionBtnTxt={'Yes'}
                                                dismisBtnTxt={'No'}>                                            
                                            </ButtonWithDialog>
                                        )}
                                        {!this.props.ExpData && (
                                            <ButtonWithDialog key={'CloneUpdate1'}
                                                CustClassName ={"BlockingDialog"}
                                                iconString={'Copy'}
                                                hideDialog={hideCloneDialog}
                                                buttonTxt={'Clone'}
                                                onBtnClick={this.handleCloneClick}
                                                buttonType={'Primary'}
                                                dialogTitle={'Clone?'}
                                                subText={"This will create a copy of this "+formHeading2+" and display it so you can update the date and other details. Do you want to proceed?"}
                                                isBlocking={false}
                                                handleAction={this.handleAddClick}
                                                actionBtnTxt={'Yes'}
                                                dismisBtnTxt={'No'}>                                            
                                            </ButtonWithDialog>
                                        )}
                                        <OutlookSyncForm ActivityDetails={{...editActivity}} Shifts={ShiftTimmings} 
                                            Locations={Locations} ActivitySyncData={ActSyncData} isSynched={ActSyncData.length>0} 
                                            disabled={!ShowSyncBtn || ActivityNotSaved ||isTBDSelected||editActivity.showVisitorField || this.isEventIdPresent()}
                                            handleActSyncSave={this.handleActSyncSave}/>
                                        <ButtonWithDialog key={'Cancel12'}
                                                CustClassName ={"BlockingDialog"}
                                                iconString={'Cancel'}
                                                hideDialog={hideCancelDialog}
                                                buttonTxt={'Cancel'}
                                                onBtnClick={this.handleCancelClick}
                                                buttonType={'Default'}
                                                dialogTitle={'Cancel?'}
                                                subText={'Changes made to '+formHeading2+' will not be saved.'}
                                                isBlocking={false}
                                                handleAction={this.handleCancelAction}
                                                actionBtnTxt={'Yes'}
                                                dismisBtnTxt={'No'}>                                            
                                        </ButtonWithDialog>
                                    </div>
                                    <div style={{display:"flex"}}>
                                        {showActControl(this.context,ActUserRole,RoleVerbs.Delete) && IsRecordEditable && (
                                            <ButtonWithDialog key={'Delete1'}
                                                CustClassName ={"BlockingDialog"}
                                                iconString={'Delete'}
                                                hideDialog={hideDeleteDialog}
                                                buttonTxt={'Delete'}
                                                onBtnClick={this.handleDelete}
                                                buttonType={'Primary'}
                                                dialogTitle={'Delete?'}
                                                subText={'Are you sure you want to delete the activity?'}
                                                isBlocking={false}
                                                handleAction={this.handleDeleteAction}
                                                actionBtnTxt={'Delete'}
                                                disabled={viewForm}
                                                dismisBtnTxt={'Cancel'}>                                             
                                            </ButtonWithDialog>
                                        )}
                                        {showActControl(this.context,ActUserRole,RoleVerbs.DeletePast)  && !IsRecordEditable && (
                                            <ButtonWithDialog key={'Delete2'}
                                                CustClassName ={"BlockingDialog"}
                                                iconString={'Delete'}
                                                hideDialog={hideDeleteDialog}
                                                buttonTxt={'Delete'}
                                                onBtnClick={this.handleDelete}
                                                buttonType={'Primary'}
                                                dialogTitle={'Delete?'}
                                                subText={'The activity belongs to the past. Are you still sure you want to delete the activity? '}
                                                isBlocking={false}
                                                handleAction={this.handleDeleteAction}
                                                actionBtnTxt={'Delete'}
                                                disabled={viewForm}
                                                dismisBtnTxt={'Cancel'}>                                             
                                            </ButtonWithDialog>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FormWrapper>
                </>
                ) : (
                <div className="centeredContainer">
                    <Spinner size={SpinnerSize.large} />
                </div>
                )}
                {SaveFlag && hideDeleteDialog?(
                    this.loadSpinner(!isClone?'Updating '+formHeading2+'...':'Cloning '+formHeading2+'...',SaveFlag)
                ):''}
                {SaveFlag && !hideDeleteDialog?(
                    this.loadSpinner('Deleting '+formHeading2+'...',SaveFlag)
                ):''}
                {isRedirect?( <Redirect to={'/Home'} /> ):''}

                {this.handleActionAndRediret()}
            </div>
        );
    }
    renderShifts = (shifts:IActivityShift[],selectedShiftIds:number[]) => {
        let options:any = shifts.map((shift:IActivityShift, key:any) => {
            if(selectedShiftIds.indexOf(shift.Id)!==-1){
                return (
                    <option
                        id={shift.Id?.toString()}
                        key={key + shift.Name}
                        value={shift.Id}
                        selected={true}>
                            {shift.DisplayName}
                    </option>
                );
            }
            else{
                return (
                    <option
                        id={shift.Id?.toString()}
                        key={key + shift.Name}
                        value={shift.Id}
                        selected={false}>
                            {shift.DisplayName}
                    </option>
                );
            }
        });
        return options;
    }
    getOptionsSelected = (options:any) => {
        var optionValues:number[] = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                optionValues.push(parseInt(options[i].id));
            }
        }
        return optionValues;
    }
    alertLSAFullyBooked = (LsaArr:ILocationShiftAvailability[],selectedUserEmail?:string):boolean =>{
        const {editActivity} = this.state;
        var fullCapLSA:ILocationShiftAvailability[] =  _.filter(LsaArr,{OnAlert:true}), raiseAlert:boolean = false;
        if(fullCapLSA.length>0){
            let filterSelection = _.filter(fullCapLSA,(lsa)=>{
                let shiftSelected = false;
                let locSelected = false;
                if(editActivity.selectedShiftIds.indexOf(lsa.ShiftId) !==-1){
                    shiftSelected = true;
                }
                if(editActivity.selectedLocations.indexOf(lsa.LocationId) !==-1){
                    locSelected = true;
                }                
                return shiftSelected && locSelected;
            });
            console.log(filterSelection);
            if(filterSelection.length>0){
                let bookedByEmail:string  =  "";
                if(!selectedUserEmail){
                    bookedByEmail = editActivity.showVisitorField?editActivity.visitorEmail:editActivity.bookedForEmail.length>0?editActivity.bookedForEmail[0].Email:"";
                }
                else{
                    bookedByEmail = selectedUserEmail;
                }
                for (let selectionIndex = 0; selectionIndex < filterSelection.length; selectionIndex++) {
                    const lsaObj:ILocationShiftAvailability = filterSelection[selectionIndex];
                    let noOfBookedFor:number = 0;
                    if(bookedByEmail && lsaObj.BookedForEmails.indexOf(bookedByEmail) === -1){
                        noOfBookedFor = lsaObj.BookedForEmails.length+1; 
                    }                 
                    if(noOfBookedFor>lsaObj.LocationCapacity){
                        raiseAlert = true;
                    }
                }
            }
        }
        return raiseAlert;
    }
    validateFields = (editActivity:IActivity) => {
        let fieldsArr = ['activityName','visitorEmail','ProjectId'],
            fieldValueArr:any = editActivity,
            flag = true,
            errorArr = ['Activity Name is required field.','Visitor Email is required field.'];
        const {ExpData} =  this.props;
        try {
            for (let i = 0; i < fieldsArr.length; i++) {
                let eachField = fieldsArr[i];
                if(eachField === 'visitorEmail'){
                    if(editActivity.showVisitorField){
                        const emailId = fieldValueArr[eachField]; 
                        if(emailId === ''){
                            this.addValidationError(errorArr[i], fieldsArr[i], flag);
                            flag = false;
                        }
                        else{
                            let checkFlag = validateEmail(emailId);
                            if (!checkFlag) {
                                let errMsg ='Visitor Email field should contain valid email.';
                                this.addValidationError(errMsg, fieldsArr[i], flag);
                                flag = false;
                            }
                        }
                    }
                }else if(eachField === 'ProjectId'){
                    if(fieldValueArr[eachField] === 0 ){
                        let errMsg ='Project/Study is required field.';
                        this.addValidationError(errMsg, fieldsArr[i], flag);
                        flag = false;
                    }
                }else {
                    if(fieldValueArr[eachField] === '') {
                        this.addValidationError(errorArr[i], fieldsArr[i], flag);
                        flag = false;
                    }
                }
            }
            if (isNaN(new Date(editActivity.activityDate).getTime())) {
                this.addValidationError('Activity Date is required field.', 'activityDate', flag);
                flag = false;
            }
            else{
                var currDate = moment(formatActivityDate(today)),
                currActivityDate = moment(editActivity.activityDate);
                var diffDates = currDate.diff(currActivityDate,'days',true);
                if( diffDates>=1 && this.state.ActUserRole !=="Admin"){
                    this.addValidationError('Activity Date should be selected from future dates.', 'activityDate', flag);
                    flag = false;
                }
            }
            if(ExpData){
                var currActivityDate = moment(editActivity.activityDate),
                currDate = moment(),
                expDate = moment(ExpData.ExpStartDate);
                var diffExpDates = expDate.diff(currActivityDate,'days');
                if(diffExpDates>0){
                    let errMsg:string ="Select Activity Date from future dates and should not be before experiment date.";
                    if(!flag && this.state.ActUserRole !=="Admin"){
                        errMsg = 'Activity Date should be selected from future dates.';
                    }
                    this.addValidationError(errMsg, 'activityDate', flag);
                    flag = false;
                }
            }
            else{
                if(editActivity.ExperimentId && editActivity.ExperimentStartDate){
                    var expDate = moment(editActivity.ExperimentStartDate);
                    var diffExpDates = expDate.diff(currActivityDate,'days');
                    if(diffExpDates>0){
                        let errMsg:string ="Select Activity Date from future dates and should not be before experiment date.";
                        if(!flag && this.state.ActUserRole !=="Admin"){
                            errMsg = 'Activity Date should be selected from future dates.';
                        }
                        this.addValidationError(errMsg, 'activityDate', flag);
                        flag = false;
                    }
                }
            }
            if (editActivity.selectedShiftIds.length<1) {
                this.addValidationError('Activity Shift is required field.', 'selectedShiftIds', flag);
                flag = false;
            }
            if (!editActivity.showVisitorField && editActivity.bookedForEmail.length<1) {
                this.addValidationError('Person Name is required field.', 'bookedForEmail', flag);
                flag = false;
            }
            if (editActivity.selectedLocations.length<1) {
                this.addValidationError('Equipment is required field.', 'selectedLocations', flag);
                flag = false;
            }
        } catch (error) {
            console.log(error);
            flag = false;
        }
        return flag;
    }
    addValidationError = (message:string, id:string, flushErrors:boolean) => {
        this.setState((previousState:any) => {
            let errorMessageArr:any = {};
            if (!flushErrors) {
                errorMessageArr = {...previousState.errorMsgs};
            }
            errorMessageArr[id] = message;
            return {
                errorMsgs: errorMessageArr,
            };
        });
    }
    IsDeleteJobOnActSync = ():boolean =>{
        const {ActSyncData} = this.state;
        let statusArr:string[] =_.map(ActSyncData,'JobStatus');
        if(statusArr.indexOf('ToDelete')!==-1){
            return false;
        }
        return true;
    }
    shouldUpdateActSync = (activityDate:Date,shiftsArr:any[] ):boolean =>{
        let flag = false;     
        let  initialActDate:any = new Date(this.initialEditActivity.activityDate);
        let initialShifts:any =  this.initialEditActivity.selectedShiftIds;
        if(initialActDate.getDate() !== activityDate.getDate() || initialActDate.getMonth() !== activityDate.getMonth() || initialActDate.getFullYear() !== activityDate.getFullYear()){
            return true;
        }
        if(shiftsArr.length !==initialShifts.length){
            return true;
        }
        for (let index = 0; index < shiftsArr.length; index++) {
            const currShift = shiftsArr[index];
            if(initialShifts.indexOf(currShift) ===-1){
                return true;
            }
        }
        for (let index = 0; index < initialShifts.length; index++) {
            const initialShift = initialShifts[index];
            if(shiftsArr.indexOf(initialShift) ===-1){
                return true;
            }
        }
        return false;
    }
    
    updateExperimentForm = (property:any,action:"UpdatedActivityAndSync"|"UpdateSync"|"RemoveSync"|"PushSync"|"LoadForm"|"CreatedActivity"|"ClonedActivity"|"UpdatedActivity"|"CloseForm"|"DeleteActivity"|"ViewToEdit") =>{
        if(this.props.ExpData){
            if(this.props.handleActivityActions){
                this.props.handleActivityActions(property, action);
            }
        }
    }
    isEventIdPresent = ():boolean =>{
        let disable:boolean = false;
        const {ActSyncData} = this.state;
        let eventIDs:string[]= _.map(ActSyncData,'EventId');
        for (let index = 0; index < eventIDs.length; index++) {
            const evenId = eventIDs[index];
            if(!evenId){
                disable = true;  
            }
        }
        let statusValues:string[]= _.map(ActSyncData,'JobStatus');
        for (let index = 0; index < statusValues.length; index++) {
            const status = statusValues[index];
            if(status === 'ToDelete' || status === 'ToInsert' ||status === 'ToUpdate'){
                disable = true;  
            }
        }
        return disable;
    } 
    handleEditClick = () =>{
        this.setState({
            viewForm:false
        });
        if(this.props.ExpData){
            this.updateExperimentForm('Changed view to update',"ViewToEdit");
        }
    }
    handleActSyncSave = (actSyncArr:IActivitySync[],action:string)  =>{
        if(action ==="Delete"){
            this.setState({
                ActSyncData:[],
                ActSyncMsg:action
            });
        }
        else{
            this.setState({
                ActSyncData:actSyncArr,
                ActSyncMsg:action
            });
        }
        if(this.props.ExpData){
            let actionForExp:any = "";            
            if(action === "Push")
                actionForExp  = "PushSync"
            if(action === "Delete")
                actionForExp  = "RemoveSync"
            if(action === "Update")
                actionForExp  = "UpdateSync"
            this.updateExperimentForm(actSyncArr,actionForExp);
        }
    } 
    handleNotesChange = (event:any)=>{
        var val = event.target.value;
        var notes:string ='';
        if(val.trim() === '') {
            notes= '';
        } else {
            notes = val;
        }
        this.setState({
            activityNotes:notes
        });
    }
    handleCancelClick = () =>{
        const {hideCancelDialog} = this.state;
        this.setState({
            hideCancelDialog:!hideCancelDialog
        });
    }
    handleCancelAction = (event:any) => {
        event.preventDefault();
        const {ExpData} = this.props;
        if(ExpData){
            this.updateExperimentForm("Close","CloseForm");
        }else{
            this.setState({
                isRedirect:true
            });
        }
    }  
    handleFormSaveClick = (ev:any) => {
        ev.preventDefault();
        const {editActivity,hideUpdateDialog,errorMsgs,LsaArr} = this.state;
        var flag = this.validateFields(editActivity);
        if (flag) {
            var alertFlag = this.alertLSAFullyBooked(LsaArr);
            errorMsgs.activityNotes = ''
            this.setState({
                hideUpdateDialog:!hideUpdateDialog,
                activityNotes:'',
                LSAFullyBooked:alertFlag,
                showErrorMsg: false,
                errorMsg: '',
                errorMsgs: InitialErrorMsg,
            });            
        } else {
            this.setState({
                showErrorMsg: true,
                errorMsg: AppConfig.ActivityForm.ErrorValidationMessage,
            });
        }
    }   
    handleUpdateAction = () =>{
        const {activityNotes,editActivity,isClone,errorMsgs} = this.state;
        this.setState({
            hideUpdateDialog:false
        });
        // if(activityNotes.length<1){
        //     errorMsgs.activityNotes = 'Please enter detailed notes before you delete.';
        //     this.setState({
        //         hideUpdateDialog:false,
        //         errorMsgs:errorMsgs
        //     });
        // }
        // else{
            errorMsgs.activityNotes = '';
            this.setState({
                SaveFlag:true,
                errorMsgs
            });
            this.callForUpdate(editActivity,AppConfig.ActivityForm.OfcAndIndiActivityType,activityNotes);
        // }
    }
    callForUpdate = (editActivity:any,activityType:string,activityNotes:string) =>{
        this.setState({SaveFlag:true});
        const {editActivityId, ActSyncData} = this.state;
        editActivity.Id= editActivityId;
        if(this.props.office){
            editActivity.selectedEquipments = [];
            editActivity.selectedLocations = [AppConfig.ActivityForm.officeSpaceUsageLocation];
        }
        let notesWithUserProfile = activityNotes +" - Modified by " + this.context.userName;        
        updateActivity(editActivity,activityType,notesWithUserProfile)
        .then(response => {
            let activityDate:any = this.state.editActivity.activityDate;
            let shiftsArr:any =  this.state.editActivity.selectedShiftIds;
            let shiftTimings:any =  this.state.ShiftTimmings;           
            if(this.shouldUpdateActSync(activityDate, shiftsArr) && ActSyncData.length>0 && this.IsDeleteJobOnActSync()){
                if(this.props.ExpData){
                    this.updateExperimentForm(editActivity,"UpdatedActivity");
                }
                //update act sync if act date/ shift are changed
                let shiftTimingsArr = SyncService.getShiftTimingsArr(activityDate, shiftsArr, shiftTimings);
                let clubShiftTimmings = SyncService.clubShiftTimings(shiftTimingsArr);
                ActivitySyncService.CallActUpdateFunction(this.state.editActivityId, editActivity.ExperimentId, clubShiftTimmings, this.context.userName);
            }else{
                if(this.props.ExpData){
                    this.updateExperimentForm(editActivity,"UpdatedActivity");
                }
            }
            if(editActivity.showVisitorField){
                let emailObj:IEmailObj = {} as IEmailObj;
                emailObj.body = this.formVisitorEmailBody(editActivity);
                emailObj.toRecipients =  process.env.REACT_APP_VISITOR_EMAIL_TO_ADD? process.env.REACT_APP_VISITOR_EMAIL_TO_ADD:"";
                emailObj.subject = process.env.REACT_APP_VISITOR_EMAIL_UPDATE_SUBJECT? process.env.REACT_APP_VISITOR_EMAIL_UPDATE_SUBJECT:"";
                sendVisitorEmail(emailObj).then((data)=>{
                    console.log(data);
                }).catch((error) =>{
                    console.log(error);
                });
            }
            this.setState({SaveFlag:false, hideUpdateDialog:true,isUpdated:true,actionType:"Update"});
        }).catch(error => {
            this.setState({
                SaveFlag:false,
                hideUpdateDialog:true,
                actionType:"Failed",
                isUpdated:false,
                showErrorMsg: true,
                errorMsg:AppConfig.ActivityForm.UpdateErrorMessage + error
            });
            console.log(error);
        });
    }
    handleCloneClick = (ev:any) => {
        ev.preventDefault();
        const {hideCloneDialog} = this.state;
        this.setState({
            hideCloneDialog:!hideCloneDialog
        });      
    }
    handleAddClick = (ev:any) => {
        ev.preventDefault();
        const {editActivity} = this.state;
        var flag = true//this.validateFields(editActivity);
        if (flag) {
            this.setState({
                showErrorMsg: false,
                errorMsg: '',
                errorMsgs: InitialErrorMsg,
            });
            this.callForCreate(editActivity,AppConfig.ActivityForm.OfcAndIndiActivityType);
        } else {
            this.setState({
                showErrorMsg: true,
                errorMsg: AppConfig.ActivityForm.ErrorValidationMessage,
            });
        }
    }
    callForCreate = (editActivity:IActivity,activityType:string) =>{
        this.setState({SaveFlag:true,isClone:true,hideCloneDialog:true});
        // let expId = editActivity.ExperimentId?editActivity.ExperimentId:null;
        let emailId = this.context.userName;
        let name = this.context.name;
        let jsonObj:any = {ActivityId:editActivity.Id,UserEmail:emailId,UserName:name};      
        cloneActivity(jsonObj).then(response => {
        let newId:any  = response?.id;
        if(this.props.ExpData){
            this.updateExperimentForm(newId,"ClonedActivity");
        }
        if(editActivity.showVisitorField){
            let emailObj:IEmailObj = {} as IEmailObj;
            emailObj.body = this.formVisitorEmailBody(editActivity);
            emailObj.toRecipients =  process.env.REACT_APP_VISITOR_EMAIL_TO_ADD? process.env.REACT_APP_VISITOR_EMAIL_TO_ADD:"";
            emailObj.subject = process.env.REACT_APP_VISITOR_EMAIL_SUBJECT? process.env.REACT_APP_VISITOR_EMAIL_SUBJECT:"";
            sendVisitorEmail(emailObj).then((data)=>{
                console.log(data);
            }).catch((error) =>{
                console.log(error);
            });
        }
        this.setState({SaveFlag:false,isCreated:true,viewForm:false,editActivityId:newId,actionType:"Clone"});
        }).catch(error => {
            this.setState({
                SaveFlag:false,
                actionType:"Failed",
                showErrorMsg: true,
                errorMsg:AppConfig.ActivityForm.CloneErrorMessage +error
            });
            console.log(error);
        });
    }
    handleDelete = () =>{
        const {hideDeleteDialog,errorMsgs} = this.state;
        errorMsgs.activityNotes = ''
        this.setState({
            hideDeleteDialog:!hideDeleteDialog,
            errorMsgs:errorMsgs,
            activityNotes:''
        });
      
    }
    handleDeleteAction= () =>{
        const {errorMsgs,editActivity} = this.state;
        let actId:number = this.state.editActivityId;
        errorMsgs.activityNotes = '';
        this.setState({
            hideDeleteDialog:false,
            SaveFlag:true,
            errorMsgs
        });
        let notesWithUserProfile = "Deleted by " + this.context.userName; 
        deleteActivityRecordByID(actId,notesWithUserProfile)
        .then(response => {
            if(this.props.ExpData){
                this.updateExperimentForm("Close","DeleteActivity");
            }
            ActivitySyncService.CallActDeleteFunction(actId);
            if(editActivity.showVisitorField){
                let emailObj:IEmailObj = {} as IEmailObj;
                emailObj.body = this.formVisitorEmailBody(editActivity);
                emailObj.toRecipients =  process.env.REACT_APP_VISITOR_EMAIL_TO_ADD? process.env.REACT_APP_VISITOR_EMAIL_TO_ADD:"";
                emailObj.subject = process.env.REACT_APP_VISITOR_EMAIL_DELETE_SUBJECT? process.env.REACT_APP_VISITOR_EMAIL_DELETE_SUBJECT:"";
                sendVisitorEmail(emailObj).then((data)=>{
                    console.log(data);
                }).catch((error) =>{
                    console.log(error);
                });
            }
            this.setState({SaveFlag:false, hideDeleteDialog:true,isDeleted:true,actionType:"Delete"});
        }).catch(error => {
            this.setState({
                SaveFlag:false,  
                isDeleted:false,
                actionType:"Failed",
                hideDeleteDialog:true,
                showErrorMsg: true,
                errorMsg:AppConfig.ActivityForm.DeleteErrorMessage + error
            });
            console.log(error);
        });
    }    
    getShiftNames = (activityDate:any, selectedShifts:number[]):string =>{
        const {ShiftTimmings} = this.state;
        let shiftString:string = "";
        let shiftTimings = SyncService.getShiftTimingsArr( activityDate, selectedShifts, ShiftTimmings);
        let clubbedShifts  = SyncService.clubShiftTimings(shiftTimings);
        let shiftsArr:string[]  = [];
        for (let s = 0; s < clubbedShifts.length; s++) {
            const shift = clubbedShifts[s];
            let str =shift.STime+"-"+shift.ETime;
            shiftsArr.push(str); 
        }        
        shiftString = shiftsArr.join(", ");
        return shiftString;
    }
    getLocationNames = (selectedLocations:number[]):string =>{
        let locationString:string = "";
        const {Locations} = this.state;
        let locArr = _.map(Locations.filter((s)=>{
            return selectedLocations.indexOf(s.LocationId) !== -1;
        }),'LocationName');
        locationString = locArr.join(", ");
        return locationString;
    } 
    getFormattedEmail = (userArr:IUserPersonaField):string =>{
        let locationString:string = "";
        locationString = "<a href='mailto:"+userArr.Email+"'>"+userArr.DisplayName+"</a>"
        return locationString;
    }
    formVisitorEmailBody = (newActivity:IActivity):string=>{
        var html:string = "", border = "text-align:center;border-bottom:solid 1px #000000;",
        borderLeftTop= "padding:8px 5px;border-top:solid 1px #000000;border-left: solid 1px #000000;", 
        borderRightSide = "border-right:solid 1px #000000;";
        let  visitorEmailObj:IUserPersonaField = {} as IUserPersonaField; 
        visitorEmailObj.Email = newActivity.visitorEmail;
        visitorEmailObj.DisplayName = newActivity.visitorEmail.split('@')[0];
        html += '<table style="'+ border +'" cellpadding="2" cellspacing="0"  >';
        html+='<tr style="border-bottom: solid 1px #000000;"><td style="'+borderLeftTop+'"><b>Name</b></td><td style="'+borderLeftTop+borderRightSide+'">'+newActivity.activityName+'</td></tr>';
        html+='<tr style="border-bottom: solid 1px #000000;"><td style="'+borderLeftTop+'"><b>Date</b></td><td style="'+borderLeftTop+borderRightSide+'">'+formatDateWithFrmt(newActivity.activityDate,"MM/DD/YYYY")+'</td></tr>';
        html+='<tr style="border-bottom: solid 1px #000000;"><td style="'+borderLeftTop+'"><b>Shift</b></td><td style="'+borderLeftTop+borderRightSide+'">'+this.getShiftNames(newActivity.activityDate, newActivity.selectedShiftIds)+'</td></tr>';
        html+='<tr style="border-bottom: solid 1px #000000;"><td style="'+borderLeftTop+'"><b>Location</b></td><td style="'+borderLeftTop+borderRightSide+'">'+this.getLocationNames(newActivity.selectedLocations)+'</td></tr>';
        html+='<tr style="border-bottom: solid 1px #000000;"><td style="'+borderLeftTop+'"><b>BookedFor</b></td><td style="'+borderLeftTop+borderRightSide+'">'+this.getFormattedEmail(visitorEmailObj)+'</td></tr>';
        html+='<tr style="border-bottom: solid 1px #000000;"><td style="'+borderLeftTop+'"><b>BookedBy</b></td><td style="'+borderLeftTop+borderRightSide+'">'+this.getFormattedEmail(newActivity.bookedByEmail)+'</td></tr>';        
        html+='</table>';
        return html;
    }
}
